<template>
  <div>
      HistoryListDefaultLayout
  </div>
</template>

<script>
export default {
  name: "HistoryListDefaultLayout",
  mixins: [],
  components: {
  },
  inject: [],
  provide() {
    return{

    }
  },
  props: {
  },
  data() {
    return{
      idx: 1,
    }
  },
  beforeRouterEnter() {},
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
  },
  methods:{
    movePage(path) {
      this.$router.push(`${path}/history`);
    },
  },
  watch: {

  },
}
</script>

<style scoped>

</style>
